module.exports = __webpack_public_path__ + "static/partner3-9c40b4a82479c415aaa76b3b55e9a1f4.png";